import React from "react";
import {IonProgressBar} from "@ionic/react";
import {formDefLoja} from "./forms";
import {QuestionarioLojaObject} from "../../../models/Questionario";
import {EventoObject} from "../../../models/Evento";
import FieldView from "../../../components/FieldView";
import {ModelForm, ModelFormField, ModelFormProps, buildModelForm} from "../../../components/ModelFormHOC";
import fb from "../../../lib/firebase";
import {AppState} from "../../../models/app";
import {AppDispatch, RootState} from "../../../global.state";
import {connect} from "react-redux";
import {DateTime} from "luxon";


interface Props extends ModelFormProps {
  app: AppState;
  dispatch: AppDispatch;
  evento: EventoObject | undefined;
  principal: any;
  instance?: QuestionarioLojaObject;
  onSubmit: () => void;
}

class _FormQuestionarioLoja extends React.Component<Props> {
  // noinspection DuplicatedCode
  onCreate = (values:any) => {
    values.principal = fb.db.doc(this.props.principal.path);
    values.tipo = this.props.evento!.principal.path.parent.id;
    values.evento = {
      label: fb.eventos.label(this.props.evento!),
      path: fb.db.collection('eventos').doc(this.props.evento!.id),
    };

    // TODO: anotar proximo evento

    return fb.document.create('questionarios', values);
  };

  onUpdate = (values:any) => {
    return fb.document.update('questionarios', this.props.instance!.id, values);
  };

  render() {
    if (!this.props.principal || !this.props.evento)
      return <IonProgressBar type="indeterminate"/>;

    return (
      <>
        <div className="flex flex-wrap">
          <div className="flex-grow">
            <FieldView value={this.props.principal.nome} label="Loja"/>
          </div>
          <div className="flex-shrink">
            <FieldView value={this.props.evento.data} label="Data evento" type="date" format="DD/MM/YYYY"/>
          </div>
        </div>

        <ModelForm
          entityLabel="Questionário"
          ownerId={this.props.app.user.uid}
          gender="m"
          instance={this.props.instance}
          formDefinition={formDefLoja}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          onComplete={this.props.onSubmit}
        >
          <ModelFormField
            field="ultimo_pedido"
            max={DateTime.now().toFormat('yyyy-MM-dd')}
          />

          <div className="text-xl font-hairline mt-4">
            Bovigen Repro Total
          </div>
          <ModelFormField field="bovigen_repro_total_quantidade"/>
          <ModelFormField field="bovigen_repro_total_valor"/>

          <div className="text-xl font-hairline mt-4">
           Bovigen Lepto 8
          </div>
          <ModelFormField field="bovigen_lepto8_quantidade"/>
          <ModelFormField field="bovigen_lepto8_valor"/>

          <div className="text-xl font-hairline mt-4">
            Bovigen V4J5
          </div>
          <ModelFormField field="bovigen_v4j5_quantidade"/>
          <ModelFormField field="bovigen_v4j5_valor"/>

          <div className="text-xl font-hairline mt-4">
            Fosfosal
          </div>
          <ModelFormField field="fosfosal_quantidade"/>
          <ModelFormField field="fosfosal_valor"/>

          <div className="text-xl font-hairline mt-4">
            Outras informações
          </div>

          <ModelFormField field="observacoes"/>
        </ModelForm>
      </>
    )
  }
}

export const FormQuestionarioLoja = connect(({app}: RootState) => ({app}))(buildModelForm(_FormQuestionarioLoja));
